import { render, staticRenderFns } from "./RedPacket.vue?vue&type=template&id=1cb3417c&scoped=true&"
import script from "./RedPacket.vue?vue&type=script&lang=js&"
export * from "./RedPacket.vue?vue&type=script&lang=js&"
import style0 from "./RedPacket.vue?vue&type=style&index=0&id=1cb3417c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3417c",
  null
  
)

export default component.exports